import { Rubriek } from "components/aangifte/Rubriek";
import React, { ChangeEvent, FunctionComponent } from "react";

export const InputField: FunctionComponent<React.InputHTMLAttributes<HTMLInputElement>> = ({ ...props }) => {
  return (
    <Rubriek code={props.name as string}>
      {({ rubriek, updateValue }) => {
        const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => updateValue(e.target.value);
        const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => updateValue(e.target.checked);
        if (props.type === "checkbox") {
          return <input checked={!!rubriek.value} onChange={handleCheckboxChange} {...props} />;
        }
        return (
          <input
            value={rubriek.value === undefined ? "" : (rubriek.value as string)}
            onChange={handleInputChange}
            {...props}
          />
        );
      }}
    </Rubriek>
  );
};

InputField.displayName = "InputField";
